import { render, staticRenderFns } from "./RegionEdit.vue?vue&type=template&id=0c6862ce"
import script from "./RegionEdit.vue?vue&type=script&lang=js"
export * from "./RegionEdit.vue?vue&type=script&lang=js"
import style0 from "./RegionEdit.vue?vue&type=style&index=0&id=0c6862ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports